
<h2>Weather forecast</h2>

<div class="nsw-block">
	<div class="nsw-table" [tabindex]="0">
		<table class="gray-bordered-table">	<!-- dummy class to circumvent bootstrap applying styles to the table -->					
			<thead>
				<tr>
					<th width="20%"></th>
					<ng-template ngFor [ngForOf]="days" let-item let-i="index">	
						<th>
							<div class="header-row">
								<span class="day-text-desktop">{{item ? (getLocalDateTime(item) | date:"EEEE") : "" }}</span>
								<span class="day-text-mobile">{{item ? (getLocalDateTime(item) | date:"EEE") : "" }}</span>
							</div>							
						</th>
					</ng-template>								
				</tr>
			</thead>
			<tbody>							
				<ng-template ngFor [ngForOf]="weatherTypes" let-weatherType let-i="index">
					
					<tr 
						*ngIf="canDisplayRow(weatherType)"
						[class.striped-row]="0 < i">
						<td class="weather-type-cell">
							<span class="weather-forecast-header-text">{{weatherType}}</span>
						</td>						
						<ng-template ngFor let-day [ngForOf]="days" let-j="index">	
							<ng-container *ngIf="j < weatherForecastData!.length;">
								<td>											
									<ng-container *ngIf="0 === i">																								
										<app-weather-forecast [forecast]="weatherForecastData![j]?.PrecisForecast "
											[airtemp]="weatherForecastData![j]?.AirTemp" [uvAlert]="weatherForecastData![j]?.UvAlert"
											[foreCastIconCode]="weatherForecastData![j]?.ForecastIconCode">
										</app-weather-forecast>
									</ng-container>

									<ng-container *ngIf="1 === i">
										<app-rainfall-forecast 
											[rainfallAmount]="weatherForecastData![j]?.RainfallAmount"
											[rainfallChance]="weatherForecastData![j]?.RainfallChance">
										</app-rainfall-forecast>
									</ng-container>

									<ng-container *ngIf="2 === i">
										<app-wind-forecast 
											[windDir]="weatherForecastData![j]?.WindDir" 
											[windSpeedKmh]="weatherForecastData![j]?.WindSpeedKmh">
										</app-wind-forecast>	
									</ng-container>

									<ng-container *ngIf="3 === i">
										<app-swell-forecast 
											[swellDirection]="weatherForecastData![j]?.SwellDirection"
											[swellHeight]="weatherForecastData![j]?.SwellHeight">
										</app-swell-forecast>
									</ng-container>

									<ng-container *ngIf="4 === i">
										<app-tide-forecast 
											[FirstTideHighHeight]="weatherForecastData![j]?.FirstTideHighHeight"
											[FirstTideHighTime]="weatherForecastData![j]?.FirstTideHighTime"
											[FirstTideLowHeight]="weatherForecastData![j]?.FirstTideLowHeight"
											[FirstTideLowTime]="weatherForecastData![j]?.FirstTideLowTime"
					
											[SecondTideHighHeight]="weatherForecastData![j]?.SecondTideHighHeight"
											[SecondTideHighTime]="weatherForecastData![j]?.SecondTideHighTime"
											[SecondTideLowHeight]="weatherForecastData![j]?.SecondTideLowHeight"
											[SecondTideLowTime]="weatherForecastData![j]?.SecondTideLowTime">
										</app-tide-forecast>
									</ng-container>
								</td>
							</ng-container>
							<ng-container *ngIf="days.length > weatherForecastData!.length && j >= weatherForecastData!.length">
								<td></td>
							</ng-container>										
						</ng-template>									
					</tr>
				</ng-template>								
			</tbody>
		</table>
	</div>
</div>
